// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + {"190":"docs","227":"worker-wx","275":"task-index","364":"task-content","385":"worker-mp","854":"info-article","983":"info-mp"}[chunkId] + "." + {"190":"71b25e56","227":"dabb8c91","275":"a1a8c768","364":"ef070bb6","385":"fa7ffaaf","854":"ae3fa629","983":"7a81fd3a"}[chunkId] + ".js";
};